// import logo from './logo.svg';
import MainLayout from './layouts/main-layout/main-layout';
import SigninPage from './pages/signin/signin';
import SignupPage from './pages/signup/signup';
import AidPage from './pages/main/aid/aid';
import FeedPage from './pages/main/feed/feed';
import { BrowserRouter, Switch } from 'react-router-dom';
// import { observer } from 'mobx-react';
import AuthRoute from './components/route/auth-route';
import AnonRoute from './components/route/anon-route';

const App = (() => {

  return (
    <BrowserRouter>
      <MainLayout>
        <Switch>
          <AnonRoute path='/' exact component={SigninPage} />
          <AnonRoute path='/signup' exact component={SignupPage} />
          <AuthRoute path='/feed' exact component={FeedPage} />
          <AuthRoute path='/aid' exact component={AidPage} />
          <AnonRoute path='/landing' component={() => {
            window.location.href = 'https://victoriasmedical.ai';
            return null;
          }} />
        </Switch>
      </MainLayout>
    </BrowserRouter>
  );
});

export default App;
